// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__TAOez","title":"Header_title__xFl0B","left":"Header_left__3TguL","clinicName":"Header_clinicName__12Hlp"};